function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, submit as submitReduxForm } from 'redux-form';
import StatefulButton from './StatefulButton';

var ReduxFormSubmitButton = function ReduxFormSubmitButton(_ref) {
  var children = _ref.children,
      dispatch = _ref.dispatch,
      invalid = _ref.invalid,
      form = _ref.form,
      submitting = _ref.submitting,
      anyTouched = _ref.anyTouched,
      array = _ref.array,
      asyncValidate = _ref.asyncValidate,
      asyncValidating = _ref.asyncValidating,
      autofill = _ref.autofill,
      blur = _ref.blur,
      change = _ref.change,
      clearAsyncError = _ref.clearAsyncError,
      clearSubmit = _ref.clearSubmit,
      clearSubmitErrors = _ref.clearSubmitErrors,
      destroy = _ref.destroy,
      dirty = _ref.dirty,
      error = _ref.error,
      handleSubmit = _ref.handleSubmit,
      initialValues = _ref.initialValues,
      initialize = _ref.initialize,
      initialized = _ref.initialized,
      pristine = _ref.pristine,
      pure = _ref.pure,
      reset = _ref.reset,
      submit = _ref.submit,
      submitFailed = _ref.submitFailed,
      submitSucceeded = _ref.submitSucceeded,
      touch = _ref.touch,
      triggerSubmit = _ref.triggerSubmit,
      untouch = _ref.untouch,
      valid = _ref.valid,
      warning = _ref.warning,
      rest = _objectWithoutProperties(_ref, ["children", "dispatch", "invalid", "form", "submitting", "anyTouched", "array", "asyncValidate", "asyncValidating", "autofill", "blur", "change", "clearAsyncError", "clearSubmit", "clearSubmitErrors", "destroy", "dirty", "error", "handleSubmit", "initialValues", "initialize", "initialized", "pristine", "pure", "reset", "submit", "submitFailed", "submitSucceeded", "touch", "triggerSubmit", "untouch", "valid", "warning"]);

  return /*#__PURE__*/React.createElement(StatefulButton, _extends({
    disabled: submitting || invalid,
    onClick: function onClick() {
      return dispatch(submitReduxForm(form));
    },
    submitting: submitting,
    type: "submit"
  }, rest), children);
};

var enhance = compose(connect(), reduxForm({}));
export default enhance(ReduxFormSubmitButton);